import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { getLanguageFromPath } from '../../utils/localeRouting';

const SITE_URL = 'https://www.drebrukaragun.com';
const DEFAULT_IMAGE = '/img/about/drebrukaragun.jpg';

const normalizePath = (path = '/') => {
  if (!path) {
    return '/';
  }

  return path.startsWith('/') ? path : `/${path}`;
};

const toAbsoluteUrl = (value) => {
  if (!value) {
    return `${SITE_URL}${DEFAULT_IMAGE}`;
  }

  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  return `${SITE_URL}${value.startsWith('/') ? value : `/${value}`}`;
};

const SEOHead = ({
  title,
  description,
  image,
  imageAlt,
  canonicalPath,
  trPath,
  enPath,
  noindex = false,
}) => {
  const location = useLocation();
  const resolvedPath = normalizePath(canonicalPath || location.pathname);
  const currentLanguage = getLanguageFromPath(location.pathname);
  const canonicalUrl = toAbsoluteUrl(resolvedPath);
  const imageUrl = toAbsoluteUrl(image || DEFAULT_IMAGE);
  const resolvedImageAlt =
    imageAlt || (currentLanguage === 'en' ? `${title} social share image` : `${title} sosyal paylasim gorseli`);

  return (
    <Helmet>
      <html lang={currentLanguage} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex,follow" /> : null}
      <link rel="canonical" href={canonicalUrl} />

      {trPath ? <link rel="alternate" hrefLang="tr" href={toAbsoluteUrl(normalizePath(trPath))} /> : null}
      {enPath ? <link rel="alternate" hrefLang="en" href={toAbsoluteUrl(normalizePath(enPath))} /> : null}
      {trPath ? <link rel="alternate" hrefLang="x-default" href={toAbsoluteUrl(normalizePath(trPath))} /> : null}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Doç. Dr. Ebru Karagün" />
      <meta property="og:locale" content={currentLanguage === 'en' ? 'en_US' : 'tr_TR'} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={resolvedImageAlt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={resolvedImageAlt} />
    </Helmet>
  );
};

export default SEOHead;
